import React from 'react'
import { FLEXY_PRODUCT_TABLE_WAREHOUSES } from '../../../utils/productTableBodegasConfig'

interface FlexyAlmacenSelectProps {
  id: string
  label: string
  value: number | ''
  onChange: (value: number) => void
  disabled?: boolean
  excludeId?: number | ''
}

const FlexyAlmacenSelect: React.FC<FlexyAlmacenSelectProps> = ({
  id,
  label,
  value,
  onChange,
  disabled = false,
  excludeId = ''
}) => {
  return (
    <div>
      <label htmlFor={id} className="block text-sm font-medium text-gray-700 mb-1">
        {label}
      </label>
      <select
        id={id}
        value={value}
        onChange={(event) => onChange(Number(event.target.value))}
        disabled={disabled}
        className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-custom-blue focus:outline-none focus:ring-1 focus:ring-custom-blue disabled:bg-gray-100"
        aria-label={label}
      >
        <option value="">Seleccionar almacén</option>
        {FLEXY_PRODUCT_TABLE_WAREHOUSES.filter(
          (warehouse) => warehouse.idalmacen !== excludeId
        ).map((warehouse) => (
          <option key={warehouse.idalmacen} value={warehouse.idalmacen}>
            {warehouse.header} — {warehouse.codigo}
          </option>
        ))}
      </select>
    </div>
  )
}

export default FlexyAlmacenSelect
